/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { IPropertyParent } from '../../core/models/common/IPropertyParent';
import { IPropertySchema } from '../../core/models/common/IPropertySchema';
import { Schema } from '../../core/models/common/Schema';

/**
 * A command used to delete a single property from a schema.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeletePropertyCommand extends AbstractCommand {
    public _propertyName : string;

    public _propertyPath : NodePath;

    public _schemaPath : NodePath;

    public _oldProperty : any;

    public _oldRequired : boolean;

    public constructor(property? : any) {
        if(((property != null && (property["__interfaces"] != null && property["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.IPropertySchema") >= 0 || property.constructor != null && property.constructor["__interfaces"] != null && property.constructor["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.IPropertySchema") >= 0)) || property === null)) {
            let __args = arguments;
            super();
            if(this._propertyName===undefined) this._propertyName = null;
            if(this._propertyPath===undefined) this._propertyPath = null;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._oldProperty===undefined) this._oldProperty = null;
            if(this._oldRequired===undefined) this._oldRequired = false;
            if(this._propertyName===undefined) this._propertyName = null;
            if(this._propertyPath===undefined) this._propertyPath = null;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._oldProperty===undefined) this._oldProperty = null;
            if(this._oldRequired===undefined) this._oldRequired = false;
            (() => {
                this._propertyName = property.getPropertyName();
                this._propertyPath = Library.createNodePath(<Node><any>property);
                this._schemaPath = Library.createNodePath((<Node><any>property).parent());
            })();
        } else if(property === undefined) {
            let __args = arguments;
            super();
            if(this._propertyName===undefined) this._propertyName = null;
            if(this._propertyPath===undefined) this._propertyPath = null;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._oldProperty===undefined) this._oldProperty = null;
            if(this._oldRequired===undefined) this._oldRequired = false;
            if(this._propertyName===undefined) this._propertyName = null;
            if(this._propertyPath===undefined) this._propertyPath = null;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._oldProperty===undefined) this._oldProperty = null;
            if(this._oldRequired===undefined) this._oldRequired = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeletePropertyCommand] Executing.");
        this._oldProperty = null;
        let property : IPropertySchema = <IPropertySchema><any>this._propertyPath.resolve(document);
        if(this.isNullOrUndefined(property)) {
            return;
        }
        let schema : IPropertyParent = <IPropertyParent><any>(<Node><any>property).parent();
        this._oldProperty = Library.writeNode(schema.removeProperty(this._propertyName));
        this._oldRequired = schema.isPropertyRequired(this._propertyName);
        if(this._oldRequired) {
            schema.unsetPropertyRequired(this._propertyName);
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeletePropertyCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldProperty)) {
            return;
        }
        let schema : IPropertyParent = <IPropertyParent><any>this._schemaPath.resolve(document);
        if(this.isNullOrUndefined(schema)) {
            return;
        }
        let propSchema : Schema = schema.createPropertySchema(this._propertyName);
        Library.readNode(this._oldProperty, propSchema);
        schema.addProperty(this._propertyName, propSchema);
        if(this._oldRequired) {
            schema.setPropertyRequired(this._propertyName);
        }
    }
}
DeletePropertyCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeletePropertyCommand";
DeletePropertyCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




